import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getCandidates = () => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getall/', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GETALL_SUCCESS',
                payload: data.candidates
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidate = (user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/get/'+ user, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const addCandidateTitle = (title, titleData, user, titleFile, type) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {

        let fileurl = ''

        if(titleFile !== null && titleFile !== undefined && titleFile !== '' && typeof titleFile !== 'string'){
            let fileData = new FormData()
            fileData.append('file', titleFile)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            fileurl = data
        }else{
            fileurl = titleFile
        }


        const { data, status } = await Axios.put('/api/client/candidate/addacademic', {'titleData': {...titleData, title: title, certificationUrl: fileurl, type}, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const deleteCandidateTitle = (title, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/removeacademic', {'title': title, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_REMOVE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const deleteCandidateTeacherFormationMaster = (user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/removeTeacherFormationMaster/' + user, {}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_REMOVE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const addCandidateWork = (companyType, workData, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/addprofessional', {
            'companyType': companyType,
            'work_data': workData,
            'user': user
        }, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const deleteCandidateWork = (work, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/removeprofessional', {'work': work, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_REMOVE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const updateAvailability = (availability, candidate) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/updateavailability/' + candidate, {'availability': availability}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_UPDATE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const addDocument = (document, filedata) => async (dispatch) => {
	try {
        let fileurl = ''

        if(document !== null && document !== undefined&& document !== '' && typeof document !== 'string'){
            let fileData = new FormData()
            fileData.append('file', document)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            fileurl = data
        }else{
            fileurl = document
        }

		const { data, status } = await Axios.put('/api/client/candidate/adddocument/', {'fileurl': fileurl, 'document_data': filedata}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
		)
		if (status === 200){
			dispatch({
				type: 'CANDIDATE_DOCUMENT_SEND_SUCCESS',
				payload: data.message
			})
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
		}
	} catch(error){
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
	}
}

export const removeDocument = (documentdata) => async (dispatch) => {
	try {
		const { data, status } = await Axios.put('/api/client/candidate/removedocument/', documentdata, {
                headers: { auth: sessionStorage.getItem('jwt') }
			}
		)
		if (status === 200){
			dispatch({
				type: 'CANDIDATE_DOCUMENT_DELETE_SUCCESS',
				payload: data.message
			}) 
		}
	} catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
	}
}

export const addProfileTypeCandidate = (profileTypedata, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/editprofiletype/' + user, profileTypedata, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_UPDATE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidatesSelection = (selection) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getcandidatesselection/'+ selection, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GETALL_SUCCESS',
                payload: data.candidates
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidatesProvinces = () => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getallwithprovinces/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GETPROVINCES_SUCCESS',
                payload: data.candidatesprovinces
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const changeSpecificFormation = (specificFormationData, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        let ibTeacherCertificateUrl = null

        if(specificFormationData.ibTeacherCertificateUrl !== null && specificFormationData.ibTeacherCertificateUrl !== undefined && specificFormationData.ibTeacherCertificateUrl !== '' && typeof specificFormationData.ibTeacherCertificateUrl !== 'string'){
            let fileData = new FormData()
            fileData.append('file', specificFormationData.ibTeacherCertificateUrl)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            ibTeacherCertificateUrl = data
        }else{
            ibTeacherCertificateUrl = specificFormationData.ibTeacherCertificateUrl
        }


        const { data, status } = await Axios.put('/api/client/candidate/changeSpecificFormation', {'specificFormationData': {...specificFormationData, ibTeacherCertificateUrl: ibTeacherCertificateUrl}, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const addCandidateCourse = (courseData, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {

        let diplomaUrl = ''

        if(courseData.diplomaUrl !== null && courseData.diplomaUrl !== undefined && courseData.diplomaUrl !== '' && typeof courseData.diplomaUrl !== 'string'){
            let fileData = new FormData()
            fileData.append('file', courseData.diplomaUrl)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            diplomaUrl = data
        }else{
            diplomaUrl = courseData.diplomaUrl
        }


        const { data, status } = await Axios.post('/api/client/candidate/addcourse', {'courseData': {...courseData, diplomaUrl: diplomaUrl}, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const deleteCandidateCourse = (course, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/removeCourse', {'course': course, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_REMOVE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const editCandidateCompetences = (user, competences) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/editCompetences', {'competences': competences, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_EDIT_COMPETENCES_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const editCandidateMethodologies = (user, methodologies) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/editMethodologies', {'methodologies': methodologies, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_EDIT_METHOLDOLOGIES_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const editCandidateTechnologies = (user, technologies) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/editTechnologies', {'technologies': technologies, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_EDIT_TECHNOLOGIES_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const addCandidateLanguage = (languageData, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {

        let titleUrl = ''

        if(languageData.titleUrl !== null && languageData.titleUrl !== undefined && languageData.titleUrl !== '' && typeof languageData.titleUrl !== 'string'){
            let fileData = new FormData()
            fileData.append('file', languageData.titleUrl)

            const {data} = await Axios.post('/api/upload/uploaddocument', fileData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            titleUrl = data
        }else{
            titleUrl = languageData.titleUrl
        }


        const { data, status } = await Axios.post('/api/client/candidate/addLanguage', {'languageData': {...languageData, titleUrl: titleUrl}, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_ADD_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const deleteCandidateLanguage = (language, user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/removeLanguage', {'language': language, 'user': user}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CANDIDATE_REMOVE_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CANDIDATE_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidateProfileStatus = (user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/checkCandidateProfileStatus/'+ user, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_STATUS_SUCCESS',
                payload: data?.status
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidateAvailableLevels = (user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getAvaliableLevels/'+ user, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_LEVELS_SUCCESS',
                payload: data?.availableLevels
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidateAvailableSubjects = (user) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/candidate/getAvailableSubjects/'+ user, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_SUBJECTS_SUCCESS',
                payload: data?.availableSubjects
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getCandidateAvailableSubjectsByCourses = (user, levels) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/candidate/getAvailableSubjectsByCourses/'+ user, { levels }, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_SUBJECTS_SUCCESS',
                payload: data?.availableSubjects
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const getTitles = () => async (dispatch) =>  {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/miscellaneous/getTitles', {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_GET_TITLES_SUCCESS',
                payload: data?.titles
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const changeIdealPositionTypeStatus = (user, idealPositionData) => async (dispatch) => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/changeIdealPositionTypeStatus/'+ user, idealPositionData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_UPDATE_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const editIdealPositionTeacher = (user, idealPositionData) => async dispatch => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/candidate/editIdealPositionTeacher/'+ user, idealPositionData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_UPDATE_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

export const reportCandidate = (candidate, reportData) => async dispatch => {
    dispatch({
        type: 'CANDIDATE_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/client/candidate/report/' + candidate, reportData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CANDIDATE_REPORT_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'CANDIDATE_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CANDIDATE_NOT_LOADING'
        })
    }
}

